import React from 'react';
import ProjectManagement from '../components/projects/ProjectManagement';

const Projects = () => {
  return (
    <div className="flex-1 flex flex-col overflow-hidden min-h-screen bg-gray-200">
      <main className="flex-1 overflow-x-hidden overflow-y-auto p-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-6 text-center">
            <h1 className="text-2xl font-semibold text-gray-900">Проекты</h1>
            <p className="text-gray-600">Добавление, удаление и просмотр проектов</p>
          </div>
          <ProjectManagement />
        </div>
      </main>
    </div>
  );
};

export default Projects; 